'use client';

import { useConfig } from '@/app/contexts/ConfigContext';
import { checkUrlCountry } from '@/helpers';

export default function TermsSpecificToCH() {
  const { config, selectedLanguage } = useConfig();

  const textToDisplay = () => {
    let innerText;
    let step;

    const resolvePrice = () => {
      const price = config.SERVICE_PRICE;
      if (price == null) {
        return null;
      }

      // Only one language
      if (typeof price === 'string') {
        return price;
      }

      // Multiple languages
      if (selectedLanguage && price[selectedLanguage]) {
        return price[selectedLanguage];
      }

      return null;
    };

    const price = resolvePrice();

    if (selectedLanguage === 'FR') {
      // One off text
      if (config.SERVICE_URL_LINK === 'chportal.bodyzenmotion.com') {
        innerText = `L'accès au service coute ${price}. Saisissez votre numéro et répondez OK (pour Salt et Sunrise). Support ?`;
        // Sub text
      } else {
        if (config.SERVICE_URL_LINK === 'chportal.apptitude.live') {
          step =
            'Saisssez votre numéro et entre le PIN reçu par SMS (pour Salt). Saisissez votre numéro et envoyez OK au 552 (pour Sunrise). Saisissez votre numéro et envoyez START ABO au 552 (pour Swisscom)';
        } else {
          step =
            'Saisissez votre numéro et répondez OUI (pour Salt et Sunrise) ou START ABO (pour Swisscom)';
        }
        innerText = `${step}. L'abonnement coûte 15 CHF par semaine (Salt et Swisscom: 3SMS/semaine. Sunrise: 1SMS/semaine). Pour résilier votre abonnement, envoyez un SMS avec le mot-clé : STOP ${config.KEYWORD} au ${config.SHORT_CODE} ou`;
      }

      return `
      ${
        config.SERVICE_NAME
      } est un service de coaching qui vous permet de visionner des dizaines de vidéos d'exercices de ${config.serviceType.toLocaleLowerCase()} animées par des coachs certifiés. Vous avez également accès à des recettes et à des articles santé. ${innerText} contactez-nous par téléphone au ${
        config.CUSTOMER_CARE_PHONE_NUMBER
      } ou par e-mail (${
        config.SERVICE_CONTACT_EMAIL
      }). En vous inscrivant sur le site web, vous reconnaissez avoir lu et accepté les conditions générales, être âgé d'au moins 18 ans et être le titulaire du compte du numéro de téléphone utilisé pour l'inscription. Service fourni par : ${
        config.COMPANY_NAME
      }, ${config.COMPANY_ADDRESS}, ${
        config.REGISTRATION_NUMBER
      }.`;
    }

    if (selectedLanguage === 'DE') {
      // One off text
      if (config.SERVICE_URL_LINK === 'chportal.bodyzenmotion.com') {
        innerText = `Die Nutzung des Services kostet ${price}. Geben Sie Ihre Nummer ein und antworten Sie mit OK (für Salt und Sunrise). Benötigen Sie Hilfe?`;
        // Sub text
      } else {
        if (config.SERVICE_URL_LINK === 'chportal.apptitude.live') {
          step =
            'Geben Sie Ihre Telefonnummer und die per SMS erhaltene PIN ein (für Salt). Geben Sie Ihre Telefonnummer ein und senden Sie OK an 552 (für Sunrise). Geben Sie Ihre Telefonnummer ein und senden Sie START ABO an 552 (für Swisscom).';
        } else {
          step =
            'Geben Sie Ihre Nummer ein und antworten Sie mit JA (für Salt und Sunrise) oder START ABO (für Swisscom).';
        }
        innerText = `${step}. Das Abo kostet 15 CHF pro Woche (Salt und Swisscom: 3SMS/woche. Sunrise: 1SMS/woche). Wen Sie das Abo beenden wollten, senden Sie eine SMS mit dem Keyword: STOP ${config.KEYWORD} an ${config.SHORT_CODE} oder`;
      }

      return `
      ${
        config.SERVICE_NAME
      } ist ein Coaching-Service, mit dem Sie Dutzende von ${config.serviceType.toLocaleLowerCase()}-Übungsvideos ansehen können, die von zertifizierte Trainer. Greifen Sie auch auf Rezepte und Gesundheitsartikel zu. ${innerText} Kontaktieren Sie uns auf unsere Hotline: ${
        config.CUSTOMER_CARE_PHONE_NUMBER
      } oder bei E-Mail (${
        config.SERVICE_CONTACT_EMAIL
      }). Durch die Registrierung auf der Website erkennen Sie an und bestätigen, dass Sie die Allgemeinen Geschäftsbedingungen gelesen haben und ihnen zustimmen, dass Sie mindestens 18 Jahre alt sind und dass Sie der Kontoinhaber der zur Registrierung verwendeten Telefonnummer sind. Dienst bereitgestellt von: ${
        config.COMPANY_NAME
      }, ${config.COMPANY_ADDRESS}, ${
        config.REGISTRATION_NUMBER
      }.
      `;
    }
  };

  return (
    <>
      {checkUrlCountry(config.SERVICE_URL_LINK, 'ch') && (
        <div style={{ color: config.theme.textColorDark }}>
          {textToDisplay()}
        </div>
      )}
    </>
  );
}
